import { useFormContext } from "../../../contexts/form-context";
import { useCheckBoxGroupContext } from "./check-box-group-context";
import { useStore } from "@tanstack/react-form";
import { CheckBox, CheckBoxProps } from "@/components/inputs";

function get<T>(
    object: T,
    pathString: string,
    defaultValue?: unknown,
): any {
    if (!pathString) return defaultValue;

    function compact<TValue>(value: TValue[]) {
        return Array.isArray(value) ? value.filter(Boolean) : [];
    }

    const result = compact(pathString.split(/[,[\].]+?/))
        .reduce((prev, key) => {
            if (prev == null) {
                return prev;
            } else {
                return prev[key];
            }
        }, object as any)


    return result === undefined || result === object
        ? object[pathString as keyof T] === undefined
            ? defaultValue
            : object[pathString as keyof T]
        : result;
};

export default function CheckBoxGroupCheckBox({ ...props }: CheckBoxProps) {
    const form = useFormContext();
    const { checkBoxes } = useCheckBoxGroupContext();

    const values = useStore(form.store, state => checkBoxes.map(name => get(state.values, name)));
    const disabled = props.disabled || form.disabled;

    const checkIndeterminate = () => {
        let prev = undefined;
        for (const value of values) {
            if (prev !== undefined && prev !== Boolean(value)) return true;
            prev = Boolean(value);
        }
        return false;
    }

    const handleSetValue = (value: boolean) => {
        checkBoxes.forEach(name => form.setFieldValue(name, value));
    }

    return <CheckBox
        {...props}

        checked={!values.every(v => !v)}
        onChange={(e, value) => {
            handleSetValue(value);
            props.onChange && props.onChange(e, value);
        }}
        indeterminate={checkIndeterminate()}
        disabled={disabled}
    />
}